/**
 * Skicka-knapp med loading state.
 *
 * disabled medan anropet pågår är hela dubbel-submit-skyddet på
 * knappsidan. Formulären förlitar sig inte enbart på den — se
 * useSubmit — men en knapp som går att trycka två gånger medan den
 * första requesten är i luften skapar två konton.
 *
 * aria-busy låter en skärmläsare säga att något pågår, och texten byts så
 * att det syns även för den som inte ser en spinner.
 */
export function SubmitButton({
  pending,
  disabled,
  children,
  pendingLabel = "Working…",
  className = "login-button",
}: {
  pending: boolean;
  /** Spärrad av annat än ett pågående anrop, t.ex. en obekräftad ruta. */
  disabled?: boolean;
  children: React.ReactNode;
  pendingLabel?: string;
  className?: string;
}) {
  return (
    <button
      className={className}
      type="submit"
      disabled={pending || disabled}
      aria-busy={pending}
    >
      {pending ? pendingLabel : children}
    </button>
  );
}
